import { UUID } from "@gx1/gx-npm-lib";
import { useSearchParams } from "react-router-dom";
import { SignupTokenType } from "../sign-up-v4.constants";

type SignupJwtBody = {
  email: string;
  initId: UUID;
  initTitle: string;
  invitedBy: string;
  surveyId: UUID;
  isFreeTrial: boolean;
};

export const useSignupToken = () => {
  const [searchParams] = useSearchParams({ token: "" });
  const token = searchParams.get("token");
  const decodedToken: SignupJwtBody = (() => {
    try {
      const parts = token?.split(".") ?? [];
      if (parts.length > 1) {
        return JSON.parse(window.atob(parts[1]));
      }
    } catch {}
  })() || {};
  const signupTokenType: SignupTokenType | undefined = (() => {
    if (decodedToken.email && decodedToken.isFreeTrial) {
      return SignupTokenType.FREE_TRIAL;
    }
    if (decodedToken.email && decodedToken.initId && !decodedToken.surveyId) {
      return SignupTokenType.INVITE_INITIATIVE;
    }
    if (decodedToken.email && decodedToken.initId && decodedToken.surveyId) {
      return SignupTokenType.INVITE_SURVEY;
    }
  })();
  return { token, signupTokenType, decodedToken };
};
